const site = site || {};
site.Animation = (() => {
    // Functions

    // const functionName = () => {
    //
    // };

    const registerGsap = () => {
        // GLOBAL ANIMATION SETTINGS
        // gsap.registerPlugin(MotionPathPlugin);
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, MotionPathPlugin);
        ScrollTrigger.config({
            limitCallbacks: true,
            ignoreMobileResize: true,
        })
    }
    
    const smoothScrolling = (mediaQueries) => {
        const smoother = ScrollSmoother.create({
            wrapper : "#smooth-wrapper",
            content: "#smooth-content",
            smooth: 1.5,
            // effects: true
            // normalizeScroll: true
        });
        smoother.effects(".js-smooth-speed [data-speed]");
        if (!window.matchMedia('(hover: none)').matches) {
            smoother.effects(".parallax-image img", { speed: "auto" });
        }

        // Anchor Linking

        const links = document.querySelectorAll('a');
        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                if (link.getAttribute('href').includes('#')) {
                    e.preventDefault();
                    const id = link.getAttribute('href');
                    console.log('click: ' + id);
                    smoother.scrollTo(id, true); // true for smooth scrolling

                }
                // let id = 
            });

        })


        
    }

    const speedCharacteristics = () => {
        // gsap.to(".parallax-image", {
        //     scrollTrigger: ".parallax-image",
        // });
    
        // MAIN NAV ITEMS - SCROLL SPEED
        gsap.to(".js-manual-speed [data-speed]", {
            y: (i, el) => (1 - parseFloat(el.getAttribute("data-speed"))) * ScrollTrigger.maxScroll(window) ,
            ease: "none",
            scrollTrigger: {
                start: 0,
                end: "max",
                invalidateOnRefresh: true,
                scrub: 0
            }
        });
        if (window.matchMedia('(hover: none)').matches) {
            const smoothSpeedObjects = document.querySelectorAll('.js-smooth-speed [data-speed]');
            smoothSpeedObjects.forEach((object) => {
                object.dataset.speed = 1;
            });
        }
    }

    const pinnedNavItems = (mediaQueries) => {
        const pinnedItems = document.querySelectorAll('.js-pinned-nav-item');
        pinnedItems.forEach((item) => {
            if (mediaQueries.xlDown.matches) {
                item.dataset.speed = .5;
                
            } else {
                item.dataset.speed = 0;
            }
        })
    }

    const popIn = () => {
        const slideLeftObjects = gsap.utils.toArray('.js-pop-in');
        if (slideLeftObjects) {
            slideLeftObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    y: 150,
                    scale: .75,
                    ease: "back.inOut(1)",
                    duration: 1,
                    scrollTrigger: {
                        trigger: object,
                        start: 'top bottom'
                    }
                });
            })
        }
    }

    const spinInLeft = () => {
        const spinInObjects = gsap.utils.toArray('.js-spin-in-left');
        if (spinInObjects) {
            spinInObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    x: 48,
                    scale: 0,
                    rotate: 270,
                    ease: "back.inOut(1)",
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: object,
                        start: 'top bottom'
                    }
                });
            })
        }
    }

    const spinInRight = () => {
        const spinInObjects = gsap.utils.toArray('.js-spin-in-right');
        if (spinInObjects) {
            spinInObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    x: -48,
                    scale: 0,
                    rotate: -270,
                    ease: "back.inOut(1)",
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: object,
                        start: 'top bottom'
                    }
                });
            })
        }
    }

    const skewElement = () => {
        if (document.querySelector('.js-skew-element')) {
            //----------------------------------------------------------------------------//
            // SKEW AN ELEMENT BASED ON THE USER'S SCROLL VELOCITY
            //----------------------------------------------------------------------------//
            let proxy = { skew: 0 },
                skewSetter = gsap.quickSetter(".js-skew-element", "skewY", "deg"), 
                clamp = gsap.utils.clamp(-10, 10); // don't let the skew go beyond 20 degrees. 
    
            ScrollTrigger.create({
                onUpdate: (self) => {
                    let skew = clamp(self.getVelocity() / -300);
                    if (Math.abs(skew) > Math.abs(proxy.skew)) {
                        proxy.skew = skew;
                        gsap.to(proxy, {
                            skew: 0,
                            duration: 0.8,
                            ease: "none",
                            overwrite: true,
                            onUpdate: () => skewSetter(proxy.skew)
                        });
                    }
                }
            });
    
            gsap.set(".js-skew-element", {
                transformOrigin: "right center",
                force3D: true
            });
        }
        
    }

    const slideDown = () => {
        const slideDownItems = gsap.utils.toArray('.js-slide-down');
        if (slideDownItems) {
            slideDownItems.forEach((item) => {
                gsap.from(item, {
                    y: -50,
                    opacity: 0,
                    ease: 'back.out(1)',
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: item,
                        start: "+=00 bottom",
                    },
                });
            });
        }
    }

    const slideUp = () => {
        const slideUpItems = gsap.utils.toArray('.js-slide-up');
        if (slideUpItems) {
            slideUpItems.forEach((item) => {
                gsap.from(item, {
                    y: 50,
                    opacity: 0,
                    ease: 'back.out(1)',
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: item,
                        start: "+=00 bottom",
                    },
                });
            });
        }
    }

    const staggerItems = () => {
        const staggerContainers = gsap.utils.toArray('.js-stagger-items-container');
        if (staggerContainers) {
            staggerContainers.forEach((container) => {
                const staggerItem = container.querySelectorAll('.js-stagger-item');
    
                gsap.from(staggerItem, {
                    opacity: 0,
                    y: 100,
                    ease: "back.inOut(4)",
                    duration: 1.25,
                    stagger: .2, 
                    scrollTrigger: {
                        trigger: container,
                        start: '+=50 bottom',
                    }
                });
            })
        }
    }
    const staggerItemsLeft = () => {
        const staggerLeftContainers = gsap.utils.toArray('.js-stagger-items-left-container');
        if (staggerLeftContainers) {
            staggerLeftContainers.forEach((container) => {
                const staggerItem = container.querySelectorAll('.js-stagger-item');
    
                gsap.from(staggerItem, {
                    opacity: 0,
                    x: 100,
                    ease: "back.inOut(4)",
                    duration: 1.25,
                    stagger: .2, 
                    scrollTrigger: {
                        trigger: container,
                        start: '+=50 bottom',
                    }
                });
            })
        }
    }

    const slideLeft = () => {
        const slideLeftObjects = gsap.utils.toArray('.js-slide-left');
        if (slideLeftObjects) {
            slideLeftObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    x: 100,
                    ease: "back.inOut(1)",
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: object,
                        start: '+=0 bottom'
                    }
                });
            })
        }
    }
    
    const slideRight = () => {
        const slideLeftObjects = gsap.utils.toArray('.js-slide-right');
        if (slideLeftObjects) {
            slideLeftObjects.forEach((object) => {
                gsap.from(object, {
                    opacity: 0,
                    x: -100,
                    ease: "back.inOut(1)",
                    duration: 1.25,
                    scrollTrigger: {
                        trigger: object,
                        start: '+=0 bottom'
                    }
                });
            })
        }
    }

    
    const gradientMesh = () => {
        //----------------------------------------------------------------------------//
        // Random Number Generator (Produces decimal values)
        //----------------------------------------------------------------------------//
        function randomInt(min, max) {
            return Math.random() * (max - min) + min;
        }
        //----------------------------------------------------------------------------//
        // GRADIENT MESH 1 ANIMATION
        //----------------------------------------------------------------------------//
        const gradientMesh1 = gsap.timeline({
            repeat: -1, 
            repeatDelay: 0, 
            yoyo: 0
        });
        //-- Phase 1 -----------------------------------------------------------------//
        gradientMesh1.to(".js-gradient-animated .gradient-blue", {
            x: randomInt(-100, 200),
            y: randomInt(-200, 100),
            rotate: randomInt(5, 9), 
            scale: randomInt(1.5, 2), 
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 0).addLabel('blue1');
        gradientMesh1.to(".js-gradient-animated .gradient-orange", {
            x: randomInt(100, 200), 
            y: randomInt(-50, 50),
            rotate: randomInt(-9, 0), 
            scale: randomInt(1, 1.25), 
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 0).addLabel('orange1');
        gradientMesh1.to(".js-gradient-animated .gradient-pink", {
            x: randomInt(-200, 100), 
            y: randomInt(-50, 50),
            rotate: randomInt(-12, 6), 
            scale: randomInt(1, 1.5),
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 0).addLabel('pink1');
        //-- Phase 2 -----------------------------------------------------------------//
        gradientMesh1.to(".js-gradient-animated .gradient-blue", {
            x: randomInt(-200, -50),
            y: randomInt(-100, 50),
            rotate: randomInt(-17, -12), 
            scale: randomInt(2, 3), 
            // opacity: randomInt(.9, 1),
            duration: randomInt(6,8),
            // ease: 'back.out(1.7)', 
        }, 'blue1').addLabel('blue2');
        gradientMesh1.to(".js-gradient-animated .gradient-orange", {
            x: randomInt(-300, 0), 
            y: randomInt(20, 75),
            rotate: randomInt(8, 11), 
            scale: randomInt(1, 1.25), 
            // opacity: randomInt(.9, 1),
            duration: 6,
            // ease: 'back.out(1.7)', 
        }, 'orange1').addLabel('orange2');
        gradientMesh1.to(".js-gradient-animated .gradient-pink", {
            x: randomInt(-100, 0), 
            y: randomInt(-50, 150),
            rotate: randomInt(-6, 6), 
            scale: randomInt(1, 1.5),
            // opacity: randomInt(.9, 1),
            duration: 6,
            // ease: 'back.out(1.7)', 
        }, 'pink1').addLabel('pink2');
        //-- Phase 3 -----------------------------------------------------------------//
        gradientMesh1.to(".js-gradient-animated .gradient-blue", {
            x: 0,
            y: 0,
            rotate: 0, 
            scale: 1, 
            opacity: 1,
            // ease: 'back.out(1.7)', 
            duration: randomInt(7,8),
        }, "blue2");
        gradientMesh1.to(".js-gradient-animated .gradient-orange", {
            x: 0,
            y: 0,
            rotate: 0, 
            scale: 1, 
            opacity: 1,
            // ease: 'back.out(1.7)', 
            duration: randomInt(6,8),
        }, "orange2");
        gradientMesh1.to(".js-gradient-animated .gradient-pink", {
            x: 0,
            y: 0,
            rotate: 0,
            scale: 1, 
            opacity: 1,
            // ease: 'back.out(1.7)', 
            duration: randomInt(6,8),
        }, "pink2");
    }

    const marquee = () => {
        const marqueeItem = gsap.utils.toArray('.marquee-item');
        
        if (marqueeItem != 0) {
            const tl = marqueeLoop(marqueeItem, {
                repeat: -1,
            });
            let speedTween;

            ScrollTrigger.create({
                trigger: marqueeItem,
                start: "top bottom",
                end: "bottom top",
                onEnter: (self) => {
                    console.log('onEnter');
                },
                onUpdate: (self) => {
                    // speedTween && speedTween.kill();
                    speedTween = gsap.timeline()
                        .to(tl, {
                            timeScale: 1 * self.direction,
                            duration: 0.25
                        })
                        .to(tl, {
                            timeScale: 1 * self.direction,
                            duration: .25
                        }, "+=0.5")
                },
                // markers: true,
            })

            function marqueeLoop(items, config) {
                items = gsap.utils.toArray(items);
                config = config || {};
                let tl = gsap.timeline({
                        repeat: config.repeat,
                        paused: config.paused,
                        defaults: {
                            ease: "none"
                        },
                        onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
                    }),
                    length = items.length,
                    startX = items[0].offsetLeft,
                    times = [],
                    widths = [],
                    xPercents = [],
                    curIndex = 0,
                    pixelsPerSecond = (config.speed || 1) * 100,
                    snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
                    totalWidth, curX, distanceToStart, distanceToLoop, item, i;

                gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
                    xPercent: (i, el) => {
                        let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
                        xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
                        return xPercents[i];
                    }
                });

                gsap.set(items, {
                    x: 0
                });

                totalWidth = items[length - 1].offsetLeft + xPercents[length - 1] / 100 * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0);

                for (i = 0; i < length; i++) {
                    item = items[i];
                    curX = xPercents[i] / 100 * widths[i];
                    distanceToStart = item.offsetLeft + curX - startX;
                    distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
                    tl.to(item, {
                            xPercent: snap((curX - distanceToLoop) / widths[i] * 100),
                            duration: distanceToLoop / pixelsPerSecond
                        }, 0)
                        .fromTo(item, {
                            xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)
                        }, {
                            xPercent: xPercents[i],
                            duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
                            immediateRender: false
                        }, distanceToLoop / pixelsPerSecond)
                        .add("label" + i, distanceToStart / pixelsPerSecond);
                    times[i] = distanceToStart / pixelsPerSecond;
                }

                function toIndex(index, vars) {
                    vars = vars || {};
                    (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
                    let newIndex = gsap.utils.wrap(0, length, index),
                        time = times[newIndex];
                    if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
                        vars.modifiers = {
                            time: gsap.utils.wrap(0, tl.duration())
                        };
                        // time += tl.duration() * (index > curIndex ? 1 : -1);
                    }
                    curIndex = newIndex;
                    vars.overwrite = true;
                    return tl.tweenTo(time, vars);
                }

                tl.next = vars => toIndex(curIndex + 1, vars);
                tl.previous = vars => toIndex(curIndex - 1, vars);
                tl.current = () => curIndex;
                tl.toIndex = (index, vars) => toIndex(index, vars);
                tl.times = times;
                tl.progress(1, true).progress(0, true); // pre-render for performance

                if (config.reversed) {
                    tl.vars.onReverseComplete();
                    tl.reverse();
                }

                return tl;
            }
        }
    }
    
    


    //----------------------------------------------------------------------------//
    //  ORBIT ANIMATION
    //----------------------------------------------------------------------------//
    const staticOrbit = () => {

        MotionPathPlugin.convertToPath("#orbit-path");
        MotionPathPlugin.convertToPath("#orbit-path-2");
        MotionPathPlugin.convertToPath("#orbit-path-3");
        
        const orbits = document.querySelectorAll('.js-static-orbit')
        
        if (orbits) {
            orbits.forEach((orbit, index) => {
                const orbitOne = orbit.querySelector('#orbit-path');
                const orbitTwo = orbit.querySelector('#orbit-path-2');
                const orbitThree = orbit.querySelector('#orbit-path-3');

                const vesselOne = orbit.querySelector('#orbiter-vessel-1');
                const vesselTwo = orbit.querySelector('#orbiter-vessel-2');
                const vesselThree = orbit.querySelector('#orbiter-vessel-3');
                
                const vessel1 = gsap.to(vesselOne, {
                    repeat: -1,
                    ease: "linear",
                    duration: 70,
                    motionPath: {
                        path: orbitOne,
                        align: orbitOne,
                        alignOrigin: [0.5, 0.5],
                        autoRotate: true,
                        start: -.75,
                        // transformOrigin: '50% 50%',
                        xPercent: -50, 
                        yPercent: -50,
                    },
                });
                const vessel2 = gsap.to(vesselTwo, {
                    repeat: -1,
                    ease: "linear",
                    duration: 35,
                    motionPath: {
                        path: orbitTwo,
                        align: orbitTwo,
                        alignOrigin: [0.5, 0.5],
                        autoRotate: true,
                        start: 0,
                        // transformOrigin: '50% 50%',
                        xPercent: -50, 
                        yPercent: -50,
                    },
                });
                const vessel3 = gsap.to(vesselThree, {
                    repeat: -1,
                    ease: "linear",
                    duration: 105,
                    motionPath: {
                        path: orbitThree,
                        align: orbitThree,
                        alignOrigin: [0.5, 0.5],
                        autoRotate: true,
                        start: -.12,
                        // transformOrigin: '50% 50%',
                        xPercent: -50, 
                        yPercent: -50,
                    },
                });

                const resizeHandler = () => {
                    vessel1.invalidate();
                    vessel2.invalidate();
                    vessel3.invalidate();
                    vessel1.play();
                    vessel2.play();
                    vessel3.play();
                };
                  
                const timer = gsap.delayedCall(0.2, resizeHandler).pause();
                window.addEventListener("resize", (event) => {
                    // animateContent();
                    // animateOrbit()
                    ScrollTrigger.refresh();
                    timer.restart(true);
                    vessel1.pause();
                    vessel2.pause();
                    vessel3.pause();
                });

            })

        }
    }

    const statBlocks = () => {
        //----------------------------------------------------------------------------//
        // STAT ANIMATIONS
        //----------------------------------------------------------------------------//
        let elements = document.querySelectorAll(".js-stat")
        const statBlocks = document.querySelectorAll(".stat-blocks")

        if (statBlocks) {

            gsap.registerEffect({
                name: "counter",
                extendTimeline: true,
                defaults: {
                    // end: 0,
                    duration: .5,
                    ease: "power1",
                    increment: 1,
                },
                effect: (targets, config) => {
                    let counterTl = gsap.timeline()
                    let num = targets[0].innerText.replace(/\,/g,'')
                    targets[0].innerText = num
            
                    counterTl.to(targets, {
                        duration: config.duration, 
                        innerText: config.end, 
                        //snap:{innerText:config.increment},
                        modifiers:{
                            innerText:function(innerText) {
                                return  gsap.utils.snap(config.increment, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        },
                        ease:config.ease,
                    }, 0)
                    return counterTl
                }
            })
    
    
            statBlocks.forEach((statBlock) => {
        
                let counterBoxTl = gsap.timeline()
        
                gsap.from(statBlock.querySelectorAll('.js-stat'), {
                    opacity: 0,
                    y: 100,
                    ease: "back.inOut(4)",
                    duration: 1.25,
                    stagger: .2, 
                    scrollTrigger: {
                        trigger: statBlock,
                        start: "+=50 bottom",
                    },
                    onStart: () => {
                        const stat1 = statBlock.querySelector('.js-stat-number-1')
                        const stat2 = statBlock.querySelector('.js-stat-number-2')
                        const stat3 = statBlock.querySelector('.js-stat-number-3')
                        const stat4 = statBlock.querySelector('.js-stat-number-4')
                
                        statBlock.style.opacity = 1;
                
                        if (statBlock.querySelector('.js-stat-number-1')) {
                            let stat1Number = stat1.dataset.statNumber;
                            counterBoxTl.counter(stat1, { 
                                end: stat1Number, 
                                ease:"linear",
                            })
                        }
                        if (statBlock.querySelector('.js-stat-number-2')) {
                            let stat2Number = stat2.dataset.statNumber;
                            counterBoxTl.counter(stat2, { 
                                end: stat2Number, 
                                ease:"linear",
                            })
                        }
                        if (statBlock.querySelector('.js-stat-number-3')) {
                            let stat3Number = stat3.dataset.statNumber;
                            counterBoxTl.counter(stat3, { 
                                end: stat3Number, 
                                ease:"linear",
                            })
                        }
                        if (statBlock.querySelector('.js-stat-number-4')) {
                            let stat4Number = stat4.dataset.statNumber;
                            counterBoxTl.counter(stat4, { 
                                end: stat4Number, 
                                ease:"linear",
                            })
                        }
                    }
                });
            })
        }
    }



    // Return
    return {
        registerGsap : registerGsap,
        smoothScrolling : smoothScrolling,
        speedCharacteristics : speedCharacteristics,
        pinnedNavItems : pinnedNavItems,
        gradientMesh : gradientMesh,
        marquee : marquee,
        popIn : popIn,
        skewElement : skewElement,
        slideDown : slideDown,
        slideUp : slideUp,
        spinInLeft : spinInLeft,
        spinInRight : spinInRight,
        staggerItems : staggerItems,
        staggerItemsLeft : staggerItemsLeft,
        slideLeft : slideLeft,
        slideRight : slideRight,
        staticOrbit : staticOrbit,
        statBlocks : statBlocks,
    };
})();